///////////////////////////////////////////////////////////////////        DETERMINE ESSENTIAL VARIABLES FOR MAP LOAD
///////////////////////////////////////////////////////////////////        BLOCK MAIN THREAD OR ABORT LOAD IF NEEDED

// create a new exception type so we can abort app load:
// to use: 'throw new FatalError("error message");'
function FatalError() {
  Error.apply(this, arguments); this.name = "FatalError";
}
FatalError.prototype = Object.create(Error.prototype);
function abortAbort(str) {
  alert(str);
  throw new FatalError(str);
} 

import { transformExtent } from 'ol/proj.js';
function transform(extent) {
  return transformExtent(extent, 'EPSG:4326', 'EPSG:3857');
}

// const siteURL = 'https://rosemaps.xyz';
const siteURL = 'https://rosemaps.tonedb.org';

// UAC Regions
// structure of regions may need to change depending on how other forecast centers work
// Currently these are chosen by the GET param 'r' so region key or id must equal that
const regions = {
  'salt-lake': {
    enabled: true,
    name: 'Salt Lake',
    urlLatestRose: siteURL + '/ut/salt-lake/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/salt-lake/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/salt-lake/',
    hillshadeTilesURL: siteURL + '/ut/salt-lake/hillshade/hillshade512_noTopo/{z}/{x}/{y}.png',
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-111.9221851, 40.48, -111.42987, 41.0126]),
    center: fromLonLat([-111.64306812856468,40.60076252774178]),
    
  },
  'salt-lake-working': {
    enabled: true,
    name: 'Salt Lake',
    urlLatestRose: siteURL + '/ut/salt-lake/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/salt-lake/last-forecast.txt',
    //urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/2.tif',
    //urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/forecast_cog_BROKEN.tif',
    //urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/forecast_cog_WORKING.tif',
    urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/forecast_cog.tif',
    //urlLatestForecastCOG: siteURL + '/ut/salt-lake/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/salt-lake/',
    hillshadeTilesURL: siteURL + '/ut/salt-lake/hillshade/hillshade512_noTopo/{z}/{x}/{y}.png',
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-111.9221851, 40.48, -111.42987, 41.0126]),
    center: fromLonLat([-111.6992, 40.57165]),
    
  },
  'logan': {
    enabled: true,
    name: 'Logan',
    urlLatestRose: siteURL + '/ut/logan/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/logan/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/logan/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/logan/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-112.224, 41.30748, -111.1414, 42.4135]),
    center: fromLonLat([-111.66668381347654, 41.90910357915783])
  },
  'provo': {
    enabled: true,
    name: 'Provo',
    urlLatestRose: siteURL + '/ut/provo/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/provo/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/provo/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/provo/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-111.8072, 39.852912, -111.0439, 40.62636]),
    center: fromLonLat([-111.54815, 40.25777])
  },
  'ogden': {
    enabled: true,
    name: 'Ogden',
    urlLatestRose: siteURL + '/ut/ogden/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/ogden/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/ogden/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/ogden/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-112.17, 40.9048, -111.1994, 41.511991]),
    //center: fromLonLat([-111.665, 41.201124])
    center: fromLonLat([-111.97432633940376, 41.3823023377399])
  },
  'uintas': {
    enabled: true,
    name: 'Uintas',
    urlLatestRose: siteURL + '/ut/uintas/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/uintas/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/uintas/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/uintas/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-111.4, 40.138, -110.35, 41.21]),
    center: fromLonLat([-110.76657458511745,40.74346596178148])
  },
  'uintas-dev': {
    enabled: true,
    name: 'Uintas',
    urlLatestRose: siteURL + '/ut/uintas/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/uintas/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/uintas/last-forecast/20231205_1.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/uintas/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-111.4, 40.138, -110.35, 41.21]),
    center: fromLonLat([-110.76657458511745,40.74346596178148])
  },
  'moab': {
    enabled: true,
    name: 'Moab',
    urlLatestRose: siteURL + '/ut/moab/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/moab/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/moab/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/moab/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    //extent: transform([-109.99174, 38.028, -108.18, 39.717]),
    extent: transform([-109.3508, 38.309, -109.0728, 38.619212]),
    center: fromLonLat([-109.23175230194808,38.53117918441603])  
  },
  'abajos': {
    enabled: true,
    name: 'Abajo',
    urlLatestRose: siteURL + '/ut/abajos/rose-image.txt',
    urlLatestForecastDate: siteURL + '/ut/abajos/last-forecast.txt',
    urlLatestForecastCOG: siteURL + '/ut/abajos/last-forecast/forecast_cog.tif',
    readForecastURLBase: 'https://utahavalanchecenter.org/forecast/abajos/',
    hillshadeTilesURL: "https://api.maptiler.com/tiles/hillshade/{z}/{x}/{y}.webp?key=Zud2jEJdF20WNcm6EB1q",
    //hillshadeTilesURL: siteURL + '/ut/salt-lake/hillshade/hillshade512_noTopo/{z}/{x}/{y}.png',
    maptilerURL: 'https://api.maptiler.com/maps/919600e2-00ba-47da-b93c-e9f75d5accad/style.json?key=Zud2jEJdF20WNcm6EB1q',
    extent: transform([-110.094, 37.43, -109.2, 38.017]),
    center: fromLonLat([-109.49407688214066,37.85620604503447])
  },
};

function sanitizeString(str) {
  str = str.replace(/[^a-z0-9:\/.-]/gim, "");
  return str.trim();
}

///////////////////////////////////////////////////////////////////        DETERMINE REGION
// Return valid region object according to GET_['r'] parameter
// default to salt-lake     OR     Abort on failure
function getRegionObjFromURL() {
  const searchParams = new URLSearchParams(location.search);
  if (searchParams == null || searchParams == '') 
    abortAbort("Could not determine forecast region"); 

  const r = sanitizeString(searchParams.get('r'));
  if (typeof regions[r] !== 'object')
    abortAbort("Could not determine forecast region");
  if (regions[r].enabled !== true)
    abortAbort("Forecast region not available");
  return regions[r];
}
const myRegion = getRegionObjFromURL();

///////////////////////////////////////////////////////////////////        DETERMINE TODAY'S DATE AND LATEST FORECAST DATE
// Create valid date object for latest forecast
// Abort upon failure
// !! Deliberate old-school synchronous fetch to prevent app from loading if we can't get a valid date
// TODO V2, convert this code and any function that depends on its result to use async await
const latestForecastDaterequest = new XMLHttpRequest();
latestForecastDaterequest.open('GET', myRegion.urlLatestForecastDate, false); // `false` makes the request synchronous
latestForecastDaterequest.send(null);

if (latestForecastDaterequest.status === 200) {
  var myLatestForecastDate = new Date(sanitizeString(latestForecastDaterequest.responseText.replace(/-/g, '/')));
  if (!(myLatestForecastDate instanceof Date && !isNaN(myLatestForecastDate))) {
    abortAbort('Could not determine latest forecast date');
  }
} else {
  abortAbort('Request for latest forecast date failed');
}



// Determine if latest forecast date is current 
const todayDateExact = new Date(Date.now() - 25200000);  // quick hack to adjust to MST
const todayDate = new Date(todayDateExact.toISOString().split('T')[0].replace(/-/g, '\/'));

let forecastDateIsCurrent = false;
if (todayDate.toISOString() == myLatestForecastDate.toISOString())
  forecastDateIsCurrent = true;


// use latest forecast date to create URL for latest UAC Danger Rose image
// abort on failure
let myRoseURL = '';
const latestRoseRequest = new XMLHttpRequest();
latestRoseRequest.open('GET', myRegion.urlLatestRose, false);
latestRoseRequest.send(null);
if (latestRoseRequest.status === 200) {
  myRoseURL = sanitizeString(latestRoseRequest.responseText);
} else {
  abortAbort('request for latest rose image failed');
}

// use latest forecast date to create date string that appears at the top of the map
// and the external URL for reading the full forecast
const dateLatestStr = myLatestForecastDate.toISOString().split('T')[0];
const dateLatestStrUAC = myLatestForecastDate.getMonth() + 1 +
  '\\' + myLatestForecastDate.getDate() + '\\' + myLatestForecastDate.getFullYear();
const myReadForecastURL = myRegion.readForecastURLBase + dateLatestStrUAC;


///////////////////////////////////////////////////////////////////        MAP
import Map from 'ol/Map';
import { View } from 'ol';

const myDefaultView = new View({
  center: myRegion.center,
  zoom: 14,
  maxZoom: 18,
  minZoom: 12,
  extent: myRegion.extent,
  smoothExtentConstraint: true,
});
const map = new Map({ target: 'map-container' });
map.setView(myDefaultView);



///////////////////////////////////////////////////////////////////        LAYERS FORECAST COG
import { fromLonLat } from 'ol/proj';
import GeoTIFF from 'ol/source/GeoTIFF';
import TileLayer from 'ol/layer/WebGLTile';


const layerForecastCOG = new TileLayer({
  source: new GeoTIFF({
    sources: [{
      url: myRegion.urlLatestForecastCOG,
      maxRanges: 12,
      cacheSize: 500,
      tileSize: 256,
      attributions: '<a href="#">Rose Maps LLC</a>, <a href="https://utahavalanchecenter.org/">Utah Avalanche Center</a>',
    }],
  }),
  
  zIndex: 10,
});
map.addLayer(layerForecastCOG);


///////////////////////////////////////////////////////////////////        LAYERS HILLSHADE
import XYZ from 'ol/source/XYZ';

const layerLocalHillshade = new TileLayer({
  source: new XYZ({
    url: myRegion.hillshadeTilesURL,
    tileSize: 512,
    minZoom: 9,
    maxZoom: 15,
    attributions: '<a href="#">Rose Maps LLC</a>, <a href="https://utahavalanchecenter.org/">Utah Avalanche Center</a>',
  }),
  extent: myRegion.extent,
  opacity: 0.5,
  zIndex: -10,
});
map.addLayer(layerLocalHillshade);


///////////////////////////////////////////////////////////////////        LAYERS MAPTILER
// for contour lines and peak name layers from MapTiler
import MapboxVectorLayer from 'ol/layer/MapboxVector';
import MapboxVector from 'ol/layer/MapboxVector';


const layerContour = new MapboxVector({
  styleUrl: myRegion.maptilerURL,
  source: 'contours',
  extent: myRegion.extent,
  zIndex: 20,
  background: false,
  maxZoom: 18,
  minZoom: 9,
});
map.addLayer(layerContour);


const layerPeaksAndRoads = new MapboxVectorLayer({
  styleUrl: myRegion.maptilerURL,
  source: 'maptiler_planet',
  extent: myRegion.extent,
  zIndex: 15,
  background: false,
  maxZoom: 18,
  minZoom: 9,
});
map.addLayer(layerPeaksAndRoads);









///////////////////////////////////////////////////////////////////        TODAY'S ROSE
import Control from 'ol/control/Control';

const roseOverlay = document.createElement('div');
roseOverlay.className = 'ol-control ol-unselectable roseOverlay';
let roseOverlayAlert = '';
if (!forecastDateIsCurrent) {
  roseOverlayAlert = '<span style="color: red;">!! Curently showing an old forecast from '
   + dateLatestStr + '</span><br>';
}
roseOverlay.innerHTML = '<a href="#" id="popup-closer" class="ol-popup-closer"></a>' +
  roseOverlayAlert + '<img src="' + myRoseURL + '" alt="Rose" />' +
  '<br><br><a href="' + myReadForecastURL + '" target="_blank">Read the Forecast</a><br />';

const roseControl = new Control({
  element: roseOverlay,
})

roseOverlay.addEventListener('click', function () {
  map.removeControl(roseControl);
});

const todayOverlay = document.createElement('div');
todayOverlay.className = 'ol-control ol-unselectable todayOverlay';
let forecastDateIsCurrentAlert = '<span style="color: red;">&nbsp; !!</span>';
if (forecastDateIsCurrent) forecastDateIsCurrentAlert = '';
todayOverlay.innerHTML = '<button title="Today">' + myRegion.name + ' ' + dateLatestStr + ' ' + forecastDateIsCurrentAlert + '</button>';
todayOverlay.addEventListener('click', function () {
  if (typeof map.removeControl(roseControl) === 'undefined')
    map.addControl(roseControl);
});
map.addControl(
  new Control({
    element: todayOverlay,
  })
);



///////////////////////////////////////////////////////////////////        POPUP "This Coordinate:"
import Overlay from 'ol/Overlay';

const popupContainer = document.getElementById('popup');
const popupContent = document.getElementById('popup-content');
const popupCloser = document.getElementById('popup-closer');
const popupOverlay = new Overlay({
  element: popupContainer,
  autoPan: {
    animation: {
      duration: 250,
    },
  },
});

popupContainer.onclick = function () {    
  popupOverlay.setPosition(undefined);
  popupCloser.blur();
  return false;
};
map.addOverlay(popupOverlay);

// Evaluate RGBA values; return elevation text
function getElevationFromForecastRGBA(forecastRGBA) {
  let alpha = forecastRGBA[3];
  // Alpha values indicate slope but we're 'trojan-ing' elevation 
  // in the alpha values by adding 1, 2, or 3.
  // Subtrack the slope alpha values, leaving the elevation code
  if (alpha >= 150) alpha -= 150; 
  if (alpha >= 80)  alpha -= 80;
  if (alpha >= 30) alpha -= 30;

  if (alpha == 3) return "Above 9500 '";
  if (alpha == 2) return "8000-9500 '";
  if (alpha == 1) return "Below 8000 '";

  return 'Not Available Here';
}

// Evaluate RGBA values; return aspect text
function getAspectFromForecastRGBA(forecastRGBA) {
  let blue = forecastRGBA[2];
  // blue values aren't used much for the danger rose colors
  // so we're 'trojan-ing' aspect by adding 1-8, for N, NE, E, ...NW
  // subtract out the visible blue value, leaving the aspect
  if (blue >= 250) blue -= 250;// norating - grey
  if (blue >= 70) blue -= 70;  //      low - green
  if (blue >= 40) blue -= 40;  //     high - red

  switch (blue) {
    case 1: return 'North';
    case 2: return 'North East';
    case 3: return 'East';
    case 4: return 'South East';
    case 5: return 'South';
    case 6: return 'South West';
    case 7: return 'West';
    case 8: return 'North West';
    default: return 'Not Available Here';
  }
}

// Evaluate RGBA values; return slope text
function getSlopeFromForecastRGBA(forecastRGBA) {
  if (forecastRGBA[3] < 5) return 'Not Available Here';
  if (forecastRGBA[3] < 35) return '0-20 &deg;';
  if (forecastRGBA[3] > 100) return '30-90 &deg;';
  return '20-30 &deg;';
}

// Evaluate RGBA values; return danger rating text
function getDangerFromForecastRGBA(forecastRGBA) {
  if (forecastRGBA[0] > 240 && forecastRGBA[1] > 240 && forecastRGBA[2] > 240 && forecastRGBA[3] < 5) return 'Outside of Region';
  if (forecastRGBA[0] > 240 && forecastRGBA[1] > 240 && forecastRGBA[2] > 240) return 'No Rating';
  if (forecastRGBA[3] < 5) return 'NA (Slope to low)';

  if (forecastRGBA[0] > 240) {
    if (forecastRGBA[1] > 240) return 'Moderate';
    else return 'Considerable';
  }

  if (forecastRGBA[2] > 60) return 'Low';
  if (forecastRGBA[0] > 190 && forecastRGBA[1] < 100) return 'High';
  if (forecastRGBA[0] < 50 && forecastRGBA[1] < 50) return 'Extreme';

  return 'Could not determine danger rating';
}

import { toLonLat} from 'ol/proj';               ////////////////////////////0
map.on('singleclick', function (evt) {
  popupContainer.style.display = 'block';
  const coordinate = evt.coordinate;


  const forecastData = layerForecastCOG.getData(evt.pixel);


  if(0){
    const hdms = toLonLat(coordinate);            ////////////////////////////// 
  // console.log('evt.pixel: ' + evt.pixel);
  // console.log('evt.coordinate: ' + evt.coordinate);
  console.log('coordinate: ' + coordinate);
  console.log('coordinate translated: ' + toLonLat(coordinate));
  // // console.log('terrainData: ' + terrainData);
  // // console.log('terrainInteger: ' + terrainInteger);
  // // console.log('elevation band: ' + getElevationFromTerrain(terrainInteger));
  // // console.log('aspect: ' + getAspectFromTerrain(terrainInteger));
  console.log('forecast data: ' + forecastData);
  console.log();
  }


  if (forecastData === null) {
    popupContent.innerHTML =
      'This coordinate:<br>' + '<br><br>No Data Available';
      // + '<br><br>' + hdms;                  //////////////////////////////
  } else {
    let pointDanger = getDangerFromForecastRGBA(forecastData);
    const pointDangerClass = styleDangerSpan(pointDanger);
    if (pointDangerClass !== '') pointDanger = '<strong>&nbsp;' + pointDanger + '&nbsp;</strong>';
    popupContent.innerHTML = 'This coordinate:<br>' +
      // '<br>' + hdms +                              //////////////////////////////
      '<br>Danger: <span class="' + pointDangerClass + '">' + pointDanger + '</span>' +
      '<br>Elevation: ' + getElevationFromForecastRGBA(forecastData) +
      '<br>Slope: ' + getSlopeFromForecastRGBA(forecastData) + '' +
      '<br>Aspect: ' + getAspectFromForecastRGBA(forecastData);
  }
  popupOverlay.setPosition(coordinate);
});

// return CSS class according to danger rating
function styleDangerSpan(t) {
  switch (t) {
    case 'Outside of Region': return 'dangerOutsideOfRegion';
    case 'No Rating': return 'dangerNoRating';
    case 'Low': return 'dangerLow';
    case 'Moderate': return 'dangerModerate';
    case 'Considerable': return 'dangerConsiderable';
    case 'High': return 'dangerHigh';
    case 'Extreme': return 'dangerExtreme';
    default: return '';
  }
}

function el(id) {
  return document.getElementById(id);
}

///////////////////////////////////////////////////////////////////        GEOLOCATE
import Feature from 'ol/Feature.js';
import Geolocation from 'ol/Geolocation.js';
import Point from 'ol/geom/Point.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';

const geolocation = new Geolocation({
  trackingOptions: {
    enableHighAccuracy: true,
  },
  projection: myDefaultView.getProjection(),
});

// update HUD when location changes
geolocation.on('change', function () {
  const mePixel = map.getPixelFromCoordinate(geolocation.getPosition());
  el('meAccuracy').innerText = (geolocation.getAccuracy() * 3.28).toFixed(0) + " '";
  let meDanger = getDangerFromForecastRGBA(layerForecastCOG.getData(mePixel));
  const meDangerClass = styleDangerSpan(meDanger);
  if (meDangerClass !== '') meDanger = '<strong>&nbsp;' + meDanger + '&nbsp;</strong>';
  el('meDanger').innerHTML = meDanger;
  el('meDanger').classList.add(meDangerClass);
  el('meElevationBand').innerText = getElevationFromForecastRGBA(layerForecastCOG.getData(mePixel));
  el('meSlope').innerHTML = getSlopeFromForecastRGBA(layerForecastCOG.getData(mePixel));
  el('meAspect').innerText = getAspectFromForecastRGBA(layerForecastCOG.getData(mePixel));
});

// handle geolocation error
geolocation.on('error', function (error) {
  alert('To use this feature, allow the browser to use location services on your device.');
  disableLocate();
});

const accuracyFeature = new Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

const positionFeature = new Feature();
positionFeature.setStyle(
  new Style({
    image: new CircleStyle({
      radius: 10,
      fill: new Fill({
        color: '#3399CC',
      }),
      stroke: new Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  })
);

geolocation.on('change:position', function () {
  const coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
});

const vsource = new VectorSource({
  features: [accuracyFeature, positionFeature],
});

new VectorLayer({
  map: map,
  source: vsource,
});

const locate = document.createElement('div');
locate.id = 'locateControl';
locate.className = 'ol-control ol-unselectable locate';
locate.innerHTML = '<button id="locateControlButton" title="Enable Tracking">➚</button>';
map.addControl(
  new Control({
    element: locate,
  })
);

const zoomToMe = document.createElement('div');
zoomToMe.id = 'zoomToMeControl';
zoomToMe.className = 'ol-control ol-unselectable zoomToMe';
zoomToMe.innerHTML = '<button id="zoomToMeButton" title="Locate me">◎</button>';
const z2me = new Control({
  element: zoomToMe,
});

function zoomToMeFunc() {
  if (!vsource.isEmpty()) {
    map.getView().fit(vsource.getExtent(), {
      maxzoom: 9,
      padding: [600, 600, 600, 600],
      duration: 800,
    });
  }
}

function disableLocate() {
  el('locateControl').style.border = '0px solid black';
  el('hudLine').style.display = 'none';
  geolocation.setTracking(false);
  positionFeature.setGeometry(null);
  accuracyFeature.setGeometry(null);
  el('zoomToMeControl').removeEventListener('click', zoomToMeFunc);
  map.removeControl(z2me);
}

el('locateControl').addEventListener('click', function () {
  if (el('locateControl').style.border != '2px solid red') {
    geolocation.setTracking(true);
    el('locateControl').style.border = '2px solid red';
    el('hudLine').style.display = 'block';
    map.addControl(z2me);
    el('zoomToMeControl').addEventListener('click', zoomToMeFunc);
  } else {
    disableLocate();
  }
});
